(function() {
  var koUtil,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  koUtil = require('resources/assets/coffee/Core/utils/knockout');

  exports.AddEditDialog = (function(superClass) {
    extend(AddEditDialog, superClass);

    function AddEditDialog(handler, data) {
      this.getGrowerYieldRange = bind(this.getGrowerYieldRange, this);
      this.getSoilTypeRange = bind(this.getSoilTypeRange, this);
      this.initGrowerRanges = bind(this.initGrowerRanges, this);
      this.setSoilsDefaults = bind(this.setSoilsDefaults, this);
      this.initSoilsRanges = bind(this.initSoilsRanges, this);
      AddEditDialog.__super__.constructor.call(this);
      this.handler = handler;
      this._orig_data = data;
      this.ignore(['_orig_data', 'soil_type_max', 'default_soils_low_yield_max', 'default_soils_high_yield_min', 'med_yield_min', 'med_yield_max', 'med_yield_min_irrigated', 'med_yield_max_irrigated', 'grower_yield_max', 'grower_med_yield_min', 'grower_med_yield_max', 'grower_med_yield_min_irrigated', 'grower_med_yield_max_irrigated']);
      this.initSoilsRanges(data);
      this.initGrowerRanges(data);
    }

    AddEditDialog.prototype.initSoilsRanges = function(data) {
      var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
      this.soil_type_max = ko.observable(500);
      this.default_soils_low_yield_max = 99;
      this.default_soils_high_yield_min = 150;
      this.low_yield_max = ko.observable(null);
      this.med_yield_min = ko.observable(null);
      this.med_yield_max = ko.observable(null);
      this.high_yield_min = ko.observable(null);
      koUtil.linkValues(this.low_yield_max, this.med_yield_min);
      koUtil.linkValues(this.med_yield_max, this.high_yield_min);
      koUtil.constrainValues(0, this.low_yield_max);
      koUtil.constrainValues(this.med_yield_min, this.med_yield_max);
      koUtil.constrainValues(this.high_yield_min, this.soil_type_max);
      this.low_yield_max((ref = (ref1 = data.zone) != null ? ref1.low_yield_max : void 0) != null ? ref : this.default_soils_low_yield_max);
      this.high_yield_min((ref2 = (ref3 = data.zone) != null ? ref3.high_yield_min : void 0) != null ? ref2 : this.default_soils_high_yield_min);
      if (data.show_irrigated_columns) {
        this.low_yield_max_irrigated = ko.observable(null);
        this.med_yield_min_irrigated = ko.observable(null);
        this.med_yield_max_irrigated = ko.observable(null);
        this.high_yield_min_irrigated = ko.observable(null);
        koUtil.linkValues(this.low_yield_max_irrigated, this.med_yield_min_irrigated);
        koUtil.linkValues(this.med_yield_max_irrigated, this.high_yield_min_irrigated);
        koUtil.constrainValues(0, this.low_yield_max_irrigated);
        koUtil.constrainValues(this.med_yield_min_irrigated, this.med_yield_max_irrigated);
        koUtil.constrainValues(this.high_yield_min_irrigated, this.soil_type_max);
        this.low_yield_max_irrigated((ref4 = (ref5 = data.zone) != null ? ref5.low_yield_max_irrigated : void 0) != null ? ref4 : this.default_soils_low_yield_max);
        return this.high_yield_min_irrigated((ref6 = (ref7 = data.zone) != null ? ref7.high_yield_min_irrigated : void 0) != null ? ref6 : this.default_soils_high_yield_min);
      }
    };

    AddEditDialog.prototype.setSoilsDefaults = function(low_yield_max, high_yield_min) {
      if (this.low_yield_max() === this.default_soils_low_yield_max && this.high_yield_min() === this.default_soils_high_yield_min) {
        this.low_yield_max(low_yield_max);
        this.high_yield_min(high_yield_min);
      }
      if (this._orig_data.show_irrigated_columns) {
        if (this.low_yield_max_irrigated() === this.default_soils_low_yield_max && this.high_yield_min_irrigated() === this.default_soils_high_yield_min) {
          this.low_yield_max_irrigated(low_yield_max);
          this.high_yield_min_irrigated(high_yield_min);
        }
      }
      this.default_soils_low_yield_max = low_yield_max;
      return this.default_soils_high_yield_min = high_yield_min;
    };

    AddEditDialog.prototype.initGrowerRanges = function(data) {
      var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
      this.grower_yield_max = ko.observable((ref = data.grower_yield_max) != null ? ref : 500);
      this.grower_low_yield_max = ko.observable(null);
      this.grower_med_yield_min = ko.observable(null);
      this.grower_med_yield_max = ko.observable(null);
      this.grower_high_yield_min = ko.observable(null);
      koUtil.linkValues(this.grower_low_yield_max, this.grower_med_yield_min);
      koUtil.linkValues(this.grower_med_yield_max, this.grower_high_yield_min);
      koUtil.constrainValues(0, this.grower_low_yield_max);
      koUtil.constrainValues(this.grower_med_yield_min, this.grower_med_yield_max);
      koUtil.constrainValues(this.grower_high_yield_min, this.grower_yield_max);
      this.grower_low_yield_max((ref1 = (ref2 = data.zone) != null ? ref2.grower_low_yield_max : void 0) != null ? ref1 : data.default_grower_low_yield_max);
      this.grower_high_yield_min((ref3 = (ref4 = data.zone) != null ? ref4.grower_high_yield_min : void 0) != null ? ref3 : data.default_grower_high_yield_min);
      if (data.show_irrigated_columns) {
        this.grower_low_yield_max_irrigated = ko.observable(null);
        this.grower_med_yield_min_irrigated = ko.observable(null);
        this.grower_med_yield_max_irrigated = ko.observable(null);
        this.grower_high_yield_min_irrigated = ko.observable(null);
        koUtil.linkValues(this.grower_low_yield_max_irrigated, this.grower_med_yield_min_irrigated);
        koUtil.linkValues(this.grower_med_yield_max_irrigated, this.grower_high_yield_min_irrigated);
        koUtil.constrainValues(0, this.grower_low_yield_max_irrigated);
        koUtil.constrainValues(this.grower_med_yield_min_irrigated, this.grower_med_yield_max_irrigated);
        koUtil.constrainValues(this.grower_high_yield_min_irrigated, this.grower_yield_max);
        this.grower_low_yield_max_irrigated((ref5 = (ref6 = data.zone) != null ? ref6.grower_low_yield_max_irrigated : void 0) != null ? ref5 : data.default_grower_low_yield_max);
        return this.grower_high_yield_min_irrigated((ref7 = (ref8 = data.zone) != null ? ref8.grower_high_yield_min_irrigated : void 0) != null ? ref7 : data.default_grower_high_yield_min);
      }
    };

    AddEditDialog.prototype.getSoilTypeRange = function(min_offset, max_offset) {
      var comp;
      comp = ko.computed((function(_this) {
        return function() {
          var i, max, min, results;
          min = 0 + min_offset;
          max = _this.soil_type_max() + max_offset;
          return (function() {
            results = [];
            for (var i = min; min <= max ? i <= max : i >= max; min <= max ? i++ : i--){ results.push(i); }
            return results;
          }).apply(this);
        };
      })(this));
      return comp;
    };

    AddEditDialog.prototype.getGrowerYieldRange = function(min_offset, max_offset) {
      var comp;
      comp = ko.computed((function(_this) {
        return function() {
          var i, max, min, results;
          min = 0 + min_offset;
          max = _this.grower_yield_max() + max_offset;
          return (function() {
            results = [];
            for (var i = min; min <= max ? i <= max : i >= max; min <= max ? i++ : i--){ results.push(i); }
            return results;
          }).apply(this);
        };
      })(this));
      return comp;
    };

    return AddEditDialog;

  })(KoModel);

}).call(this);
